import styled from 'styled-components';
import { SelectProps } from './types';

export const Select = ({ children, defaultValue, direction = 'vertical', label, name, onChange }: SelectProps) => {
  const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value) {
      onChange(event.target.value);
    }
  };

  return (
    <SelectWrapper direction={direction}>
      <Label htmlFor={name}>{label}</Label>
      <SelectInput defaultValue={defaultValue} id={name} name={name} onChange={onSelectChange}>
        {children}
      </SelectInput>
    </SelectWrapper>
  );
};

export const Option = ({ children, value }: { value: string; children: React.ReactNode }) => {
  return <option value={value}>{children}</option>;
};

Select.Option = Option;

export default Select;

const SelectWrapper = styled.div<Pick<SelectProps, 'direction'>>`
  width: 100%;
  display: flex;
  flex-direction: ${({ direction }) => (direction === 'vertical' ? 'column' : 'row')};
  gap: 4px;
`;

const Label = styled.label`
  color: ${({ theme }) => theme.colorPalette.gray500};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 157.143% */
`;

const SelectInput = styled.select`
  outline: none;
  height: 32px;
  padding: 4px 16px 4px 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colorPalette.gray50};
  color: ${({ theme }) => theme.colorPalette.blue500};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;
